import * as Sentry from '@sentry/browser'

export const sendErrorToSentry = (error, context = {}) => {
    Sentry.withScope((scope) => {
        for (const key in context) {
            scope.setExtra(key, context[key])
        }

        // Check if the error is an object and has a message property
        if (typeof error === 'object' && error !== null && error.message) {
            Sentry.captureException(new Error(error.message))
        } else {
            Sentry.captureException(error)
        }
    })
}

window.sendErrorToSentry = sendErrorToSentry

export default sendErrorToSentry